import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d267364"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Farbe auswählen", -1))
const _hoisted_2 = { class: "color-picker" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "check", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Tag anpassen",
    icon: "label"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Änderungen am Namen und der Farbe werden automatisch für alle Konversationen übernommen. ")
    ]),
    body: _withCtx(() => [
      _createVNode(_component_md_input_field, {
        onKeypress: _withKeys(_ctx.updateTag, ["enter"]),
        variant: "outlined",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
        label: "Name",
        ref: "nameInput",
        validator: _ctx.nameValidator
      }, null, 8, ["onKeypress", "modelValue", "validator"]),
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, k) => {
          return (_openBlock(), _createElementBlock("li", {
            key: k,
            class: _normalizeClass({ active: this.color === k }),
            onClick: ($event: any) => (this.color = k)
          }, [
            _createVNode(_component_md_tooltip, {
              position: "bottom",
              text: color.name
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "circle",
                  style: _normalizeStyle({ 'background-color': color.color })
                }, _hoisted_5, 4)
              ]),
              _: 2
            }, 1032, ["text"])
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.updateTag
      }, {
        default: _withCtx(() => [
          _createTextVNode("Änderungen speichern")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}